module.exports = __webpack_public_path__ + "static/media/napster.547e28b5.svg";